module.exports = __webpack_public_path__ + "img/a_altramuz.89a2fa3d.svg";